import React from 'react';
import MobileHeader from './MobileHeader';
import MobileTabs from './MobileTabs';
import MobilePortfolioTab from './MobilePortfolioTab';
import MobilePropertiesTab from './MobilePropertiesTab';
import MobileResponsesTab from './MobileResponsesTab';
import MobileQRTab from './MobileQRTab';
import MobilePropertyDrawer from './MobilePropertyDrawer';
import { CircularLoader } from '../../ui';

const MobileLayout = ({
  activeTab,
  setActiveTab,
  propertyTab,
  portfolio,
  loadingState,
  availableTags
}) => {
  return (
    <div className="flex flex-col h-full overflow-hidden bg-white relative">
      {/* Circular loader - shows during actual data operations */}
      <CircularLoader
        isLoading={loadingState?.isLoading}
        overlay={true}
        size="lg"
      />

      {/* Header */}
      <header className="flex-shrink-0 bg-white/95 backdrop-blur-md border-b border-notion-border z-20 sticky top-0">
        <MobileHeader portfolio={portfolio} />
        <MobileTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto bg-stone-50 pb-24 p-4">
        {activeTab === 'portfolio' && portfolio && (
          <MobilePortfolioTab portfolio={portfolio} />
        )}

        {activeTab === 'properties' && (
          <MobilePropertiesTab
            properties={propertyTab.properties}
            onAddProperty={propertyTab.handleAddProperty}
            onPropertyClick={(id) => propertyTab.handlePropertyClick(id)}
          />
        )}

        {activeTab === 'responses' && (
          <MobileResponsesTab propertyTab={propertyTab} portfolio={portfolio} />
        )}

        {activeTab === 'qr' && (
          <MobileQRTab propertyTab={propertyTab} portfolio={portfolio} />
        )}
      </main>

      {/* Property Drawer */}
      <MobilePropertyDrawer
        propertyTab={propertyTab}
        availableTags={availableTags}
      />
    </div>
  );
};

export default MobileLayout;
